import { StatusType, status } from '../typeStatus'

// seteo y reseteo del cupon de descuento
export const SET_COUPON_CODE = 'SET_COUPON_CODE'
export const COUPON_CODE_RESET = 'COUPON_CODE_RESET'
export const GET_COUPON = 'GET_COUPON'
export const GET_COUPON_SUCCESS = 'GET_COUPON_SUCCESS'
export const GET_COUPON_ERROR = 'GET_COUPON_ERROR'

export interface Coupon {
  couponCode: string | null
  status: StatusType
}

export interface CouponState {
  couponCode: string | null
  fetchCoupon: Coupon
}

const initialStateFetchCoupon = {
  couponCode: null,
  status: status.initial,
}

export const InitialState: CouponState = {
  couponCode: null,
  fetchCoupon: initialStateFetchCoupon,
}

export interface SetCouponCode {
  type: typeof SET_COUPON_CODE
  payload: string
}

export interface CouponCodeReset {
  type: typeof COUPON_CODE_RESET
  payload: null
}

export interface GetCoupon {
  type: typeof GET_COUPON
  payload: null
}

export interface GetCouponSuccess {
  type: typeof GET_COUPON_SUCCESS
  payload: string
}

export interface GetCouponError {
  type: typeof GET_COUPON_ERROR
  payload: null
}

export type CouponActions = SetCouponCode | CouponCodeReset | GetCoupon | GetCouponSuccess | GetCouponError
